import { Component, ElementRef, OnInit, OnChanges, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';

import { Message } from 'src/app/models/message';
import { Biblio } from 'src/app/models/obs/biblio';
import { Comment } from 'src/app/models/obs/comment';
import { Graphic } from 'src/app/models/obs/graphic';
import { Meeting } from 'src/app/models/obs/meeting';
import { PrimarySource } from 'src/app/models/obs/primarysource';
import { Section } from 'src/app/models/obs/section';
import { Subsection } from 'src/app/models/obs/subsection';
import { Tier3 } from 'src/app/models/obs/tier3';
import { BiblioService } from 'src/app/services/obs/biblio.service';
import { GraphicService } from 'src/app/services/obs/graphic.service';
import { PrimarysourceService } from 'src/app/services/obs/primarysource.service';
import { SectionService } from 'src/app/services/obs/section.service';
import { SubsectionService } from 'src/app/services/obs/subsection.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { NewsService } from '../../../services/obs/news.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tematic } from 'src/app/models/obs/tematic';
import { SearchService } from 'src/app/services/search.service';


@Component({
  selector: 'app-ficha',
  templateUrl: './ficha.component.html',
  styleUrl: './ficha.component.scss'
})
export class FichaComponent implements OnInit, OnChanges {

  t3: Tier3 = null;
  sections: Section[] = [];
  subsections: Subsection[] = [];
  biblio: Biblio[] = [];
  primarySource: PrimarySource[] = [];

  generalGraph: Graphic[] = [];
  line: Graphic[] = [];
  col: Graphic[] = [];
  col_gr: Graphic[] = [];
  bar: Graphic[] = [];
  bar_gr: Graphic[] = [];
  table: Graphic[] = [];
  img: Graphic[] = [];
  img_ref: Graphic[] = [];
  datawrapper: Graphic[] = [];

  comm: Comment[] = [];
  meet: Meeting[] = [];

  band: boolean = false;
  msg: Message;

  lastUpdated = new Date(null);
  isUploadDir: boolean = false;
  URL: string = urlEndPoint;
  topDOM: string;
  widthDOM: string;


  c: Comment[] = [
    {
      idtier3: 23,
      name: 'Diana Silvera',
      date: new Date('12/12/2020'),
      detail: 'Considero que el acercamiento de la población a los servicios de salud, desde el punto de vista de haber trabajado con agentes comunitarios, es una oportunidad muy importante que nos permite ver que contando con ese tipo de actores, que son un recurso valioso a nivel comunitario, permite lograr más rápidamente los resultados de reducción de anemia. ',
    }
  ];

  @ViewChild("divref", { static: false }) divRef: ElementRef;

  codeDatawrapper;
  sanitized;

  constructor(
    private router: Router,
    private searchService: SearchService,
    private tematicS: TematicService,
    private actRoute: ActivatedRoute,
    private t3S: Tier3Service,
    private sectS: SectionService,
    private subS: SubsectionService,
    private graphS: GraphicService,
    private biblioS: BiblioService,
    private primaryS: PrimarysourceService,
    private render: Renderer2,
    private render2: Renderer2,
    private domSanitizer: DomSanitizer,
    private newsService: NewsService) {
    this.sanitized = domSanitizer.bypassSecurityTrustHtml(this.codeDatawrapper);
  }

  ngOnInit() {
    var w = window.innerWidth;
    var h = window.innerHeight;
    this.getTier3();
    this.renderer(w, h);
  }

  ngOnChanges() {

  }

  renderer(w: number, h: number) {
    if (w > 1360) {
      this.topDOM = '450px';
      this.widthDOM = '1120px';
    }
    if (w > 1516) {
      this.topDOM = '450px';
      this.widthDOM = '1190px';
    }
    if (w > 1700) {
      this.topDOM = '450px';
      this.widthDOM = '1300px';
    }
    if (w > 1820) {
      this.topDOM = '450px';
      this.widthDOM = '1360px';
    }
    if (w > 2040) {
      this.topDOM = '450px';
      this.widthDOM = '1460px';
    }

  }

  renderer2() {
    this.render.listen('window', 'load', () => {
      setTimeout(() => {
        this.topDOM = this.divRef.nativeElement.getBoundingClientRect().top + 20 + 'px';
        this.widthDOM = this.divRef.nativeElement.getBoundingClientRect().right - 80 + 'px';
        //this.widthDOM = 500 + 'px';
        //console.log("rect: ", top);
        // console.log("DOM: ", this.divRef.nativeElement.getBoundingClientRect());

      }, 1000);

    });
  }


  verifiedImgDirectory() {
    if (this.t3.img != null) {
      (this.t3.img.substr(1, 6) == 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  getTier3() {
    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      this.t3S.get4code(params['id']).subscribe({
        next: res => {
          this.t3 = res['data'];
          this.verifiedImgDirectory();
          this.getSection4T3(this.t3.id);
          this.getGr4T3(this.t3.id);
          this.getBbl4T3(this.t3.id);
          this.getComments(this.t3.id);
          this.getPrimarySource4T3(this.t3.id);
          //capturamos tags de la ficha actual
          this.getRelatedNews(this.t3.tags)
          this.getRelatedTier3(this.t3.id, this.t3.tags);
          this.getTematic(String(this.t3.idtematic));
          this.addViewToTier3();
        },
        error: err => console.error(err)
      });
    }
  }


  /* Metodo para agregar visita a fichas */
  addViewToTier3() {
    if (this.t3.id) {
      const id = (this.t3.id).toString()
      this.t3S.addViewToTier3(id).subscribe({
        next: res => {
          console.log('thank');
        },
        error: err => console.error(err)
      });
    }
  }

  //metodo para buscar las coincidencias de tags entre ficha(tier3) y noticias(news)
  tempRelated = {};
  news = [];
  newsFlag = 0;
  getRelatedNews(relatedTier3: string) {
    this.tempRelated['related'] = relatedTier3;
    const data = this.tempRelated
    this.newsService.getRelatedNewsForTier3(data).subscribe({
      next: res => {
        if (res['data'].length > 0) {
          this.newsFlag = 1;
          this.news = res['data'];
        }
      },
      error: err => { console.error(err) }
    })


  }

  getPrimarySource4T3(id: number) {
    this.primaryS.get4T3(id).subscribe({
      next: res => {
        this.primarySource = res['data'];
      },
      error: err => console.error(err)
    });
  }

  getSection4T3(id: number) {
    this.sectS.get4T3(id).subscribe({
      next: res => {
        this.sections = res['data'];
        this.getSubsection4Sec(this.sections);
      },
      error: err => console.error(err)
    });
  }

  getSubsection4Sec(sec: Section[]) {
    this.subsections = [];
    sec.forEach(o => {
      let i = 0;
      this.subS.get4sec(o.id + '').subscribe({
        next: res => {
          let temp: Subsection[] = [];
          temp = res['data'];
          temp.forEach(p => {
            this.subsections.push(p)
          });
          temp = null;
          //this.getLastUpdated(this.sections, this.subsections);
        },
        error: err => console.error(err)
      });
    });
  }

  getGr4T3(id: number) {
    this.generalGraph = [];
    this.graphS.getGr4T3(id).subscribe({
      next: res => {
        this.generalGraph = res['data'];
        this.assignGraph(this.generalGraph);
      },
      error: err => { this.msg = err; }
    });
  }

  biblioAll: [];
  flagBiblio = 0;// mediante esta bandera determinamos si el contenido excede los 10 registros
  flagShowMore = 0;//mediante esta bandera determiniamos si el boton ver mas esta activo o no
  action = 'Ver más';// instanciamos la variable action para modificar el contenido del botona ver mas a ver menos.
  
  getBbl4T3(id: number) {
    this.biblioS.get4T3(id).subscribe({
      next: res => {
        if (Object.keys(res['data']).length > 10) {
          this.biblioAll = res['data'];
          this.flagBiblio = 1;
          this.flagShowMore = 1;
          this.biblio = res['data'].slice(0, 10);
        } else {
          this.flagBiblio = 0;
          this.biblio = res['data']
        }
      },
      error: err => { this.msg = err; }
    });
  }


  //permite visualizar mas referencias bibliograficas minimo 10
  showMore() {
    if (this.flagShowMore == 1) {
      this.action = 'Ver menos';
      this.biblio = this.biblioAll;
      this.flagShowMore = 0;
    } else {
      this.action = 'Ver más';
      this.biblio = this.biblio.slice(0, 10);
      this.flagShowMore = 1;
    }

  }

  getComments(id: number) {
    this.comm = [];
    this.c.forEach(o => {
      if (o.idtier3 == id) {
        this.comm.push(o);
      }
    });
  }

  getLastUpdated(s: Section[], sub: Subsection[]) {
    let date = new Date("12/31/2000");
    sub.forEach(p => {
      if ((new Date(p.updatedAt)) > date) {
        date = p.updatedAt
      }
    });
    if ((new Date(date)) > new Date("12/31/2000")) {
      this.lastUpdated = date;
    } else {
      this.lastUpdated = null
    }
    date = null;
  }

  assignGraph(g: Graphic[]) {
    this.line = [], this.col = [], this.col_gr = [], this.img = [], this.img_ref = [];
    g.forEach(o => {
      o.directory = o.urldata.substring(1, 7);
      switch (o.idgraphictype) {
        case 10: {
          this.isGraph();
          this.img.push(o);
          break;
        }
        case 11: {
          this.img_ref.push(o);
          break;
        }
        case 12: {
          this.datawrapper.push(o);
          this.isGraph();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1);
  }

  isGraph() {
    this.band = true;
  }

  tier3Related = [];
  getRelatedTier3(id: number, tags: string) {
    let data = { idTier3: id, keywords: tags }
    this.t3S.getRelatedContent(data).subscribe(
      res => {
        this.tier3Related = res as [];
      },
      err => { console.error(err) }
    )
  }

  tematic: Tematic;
  getTematic(id: string) {
    this.tematicS.getOne(id).subscribe(
      res => {
        this.tematic = res['data'];
      },
      err => { console.error(err) }
    )
  }

  buscarPorKeyword(keyword: string) {
    this.searchService.options$ = this.searchService.getRelatedTier3ForSeek(keyword);
    this.router.navigate(['/search-results-list']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    });
    this.searchService.shooterFirstPagePaginator.emit({
      data: 1,
      termSearch: keyword
    });
  }

  isLastTag(tag: string): boolean {
    return this.t3.tags.split(',').pop().trim() === tag.trim();
  }

}
